import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import UserViewContainer from '@src/components/user/view/UserViewContainer';

const MyProfilePage = (props: WithRouterProps) => <UserViewContainer userId={props.params.userId} openedTab={props.params.openedTab} baseRoute="myprofile" />;

export default withRouter(MyProfilePage);
